import { render, staticRenderFns } from "./RightsHolderBatchesList.vue?vue&type=template&id=b2c9dfb6&"
import script from "./RightsHolderBatchesList.vue?vue&type=script&lang=js&"
export * from "./RightsHolderBatchesList.vue?vue&type=script&lang=js&"
import style0 from "./RightsHolderBatchesList.vue?vue&type=style&index=0&id=b2c9dfb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports